import axios from 'axios'
import moment from 'moment'
import store from '../../../store'

const setList = ({ commit }, payload) => {
  if (!payload) return false
  return new Promise((resolve, reject) => {
    axios.get(`${process.env.URL}/my-clinic-new/patient/medical-record`, {
      params: {
        customer: store.state.customer,
        patient: payload
      }
    })
      .then(function (response) {
        // handle success
        const items = response.data.results.results.map((item) => {
          return {
            date: moment(item.tbData, 'DD/MM/YYYY').format('DD/MM'),
            hour: moment(item.tbHora, 'LTS').format('HH'),
            doctor: item.tbNomeMedico.substring(0, 10),
            history: item.tbDescricao
          }
        })
        resolve(commit('SET_LIST', items))
      })
      .catch(function (error) {
        // handle error
        console.log('err', error)
        reject(error)
      })
      .then(function () {
        // always executed
      })
  })
}

const setAvailableAppointments = ({ commit }, schedule) => {
  commit('SET_AVAILABLEAPPOINTMENTS', schedule)
}

export default {
  setList,
  setAvailableAppointments
}



// WEBPACK FOOTER //
// ./src/store/modules/exam/actions.js